module.exports = __webpack_public_path__ + "images/FUSA_icons/089-credit-card.e97a9b5c469f782bc7253dcb2188ecce.svg";